import { z } from 'zod';
import { AiHarnessModelProfiles, AiHarnessProfile } from './ai-harness-profile.js';
export const AiHarnessVersion = z.enum(['v1', 'v2', 'v3', 'v4', 'v4.1']);
/** Persisted with the run, so changing defaults cannot silently change a resumed run. */
export const AiHarnessSelection = z.object({
    version: AiHarnessVersion,
    defaultProfile: z.union([AiHarnessProfile, z.literal('auto')]),
    modelProfiles: AiHarnessModelProfiles,
});
export const AiHarnessRelease = z.object({
    version: AiHarnessVersion,
    releasedAt: z.string(),
    title: z.string(),
    changes: z.array(z.string()),
});
export const AiHarnessVersionsView = z.object({
    activeVersion: AiHarnessVersion,
    releases: z.array(AiHarnessRelease),
});
//# sourceMappingURL=ai-harness-version.js.map